import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dropdown } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import "../../assets/styles/local/Stock.css";
import Header from "../../layouts/Header";
import moment from "moment";
import { FetchActiveUsers } from "../../redux/actions/action";
import "../../assets/styles/local/payroll.css";
import plusIcon from "../../assets/icons/Plus.svg";
import PayrollActiveUserModal from "./PayrollActiveUserModal";
import simpleRequest from "../../utils/helpers/simpleRequest";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import Pagination from "../../components/Pagination/Pagination";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const PayrollEdit = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    state: { state },
  } = useLocation();
  const companyId = window.localStorage.getItem("companyid");
  const [users, setUsers] = useState([]);
  const [rows, setRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const activeStatusResponse = useSelector(
    (state) => state.user.activeStatusResponse
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Payroll").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  useEffect(() => {
    setCurrentPage(0);
  }, [perPage, currentPage]);

  const totalCost = useMemo(
    () =>
      rows[0]?.payrollExpense?.reduce(
        (acc, curr) => +acc + (+curr?.grosswage + +curr?.companyTax),
        0
      ),
    [rows]
  );

  const handleAddRow = (user) => {
    let list = [...rows[0]?.payrollExpense];
    const userIndex = list.findIndex((item) => item?.userId === user?.userid);
    if (userIndex >= 0) return;
    const newRow = {
      username: user.firstname,
      grosswage: user.wagerate,
      employeeTax: "",
      netWage: "",
      companyTax: "",
      totalPayrollCost: "",
      description: "",
      userId: user?.userid,
    };
    setRows([
      { ...rows[0], payrollExpense: [...rows[0]?.payrollExpense, newRow] },
    ]);
  };

  const handleDeleteRow = (index) => {
    const updatedRows = [...rows];
    updatedRows[0].payrollExpense = updatedRows[0]?.payrollExpense.filter(
      (_, rowIndex) => rowIndex !== index
    );
    setRows(updatedRows);
  };

  const filteredUsers = users?.filter((user) =>
    user.firstname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleInputChange = (index, field, value) => {
    const updatedRows = [...rows];
    const updatedPayrollExpense = [...updatedRows[0]?.payrollExpense];
    updatedPayrollExpense[index][field] =
      field === "description" ? value : parseFloat(value);
    updatedRows[0] = {
      ...updatedRows[0],
      payrollExpense: updatedPayrollExpense,
    };
    setRows(updatedRows);
  };

  const calculateNetWage = (grosswage, employeeTax) => grosswage - employeeTax;
  const calculateTotalPayrollCost = (grosswage, companyTax) =>
    +grosswage + +companyTax;

  const handleSubmit = async () => {
    let data = [];
    rows[0]?.payrollExpense?.map((item) =>
      data.push({
        payrollExpensiveId: item?.payrollExpensiveId ?? undefined,
        userId: item?.userId,
        grosswage: item?.grosswage,
        employeeTax: item?.employeeTax,
        netwage: Number(item?.grosswage) - Number(item?.employeeTax),
        companyTax: item?.companyTax,
        totalPayrollCost: Number(item?.grosswage) + Number(item?.companyTax),
        description: "",
      })
    );
    const payload = {
      payrollHistoryId: rows[0].payrollHistoryId,
      noofEmployee: rows[0]?.payrollExpense.length,
      totalCost: totalCost,
      payrollUser: data,
    };
    const resp = await simpleRequest(
      `/api/Payroll/UpdatePayroll`,
      "post",
      payload
    );
    if (resp?.status === true) history.goBack();
  };

  useEffect(() => {
    dispatch(FetchActiveUsers(companyId));
  }, [dispatch, companyId]);

  useEffect(() => {
    if (activeStatusResponse != null) {
      if (activeStatusResponse?.status && activeStatusResponse?.data) {
        setUsers(activeStatusResponse?.data);
      }
    }
  }, [activeStatusResponse]);

  const fetchPayrollById = async () => {
    const resp = await simpleRequest(`/api/Payroll/FetchPayrollById`, "post", {
      // payrollHistoryId: state.payrollHistoryId ?? "",
      payrollHistoryId: "",
      pagerequire: perPage,
      pagenumber: currentPage + 1,
    });
    if (resp?.status) {
      setRows(resp?.data);
      const totalRecords =
        resp?.data?.totalCount ?? resp?.data[0]?.payrollExpense.length;
      const newTotalPages = Math.ceil(totalRecords / perPage);
      setTotalPages(newTotalPages);
    }
  };

  useEffect(() => {
    fetchPayrollById();
  }, [perPage, currentPage]);

  return (
    <>
      <Header
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/payroll");
              }}
            >
              {/* Payroll */}
              {t("Payroll")}
            </div>
            <p className="products-and-parts-sub-title products_and_parts_sub_title">
              {/* Edit Current Payroll */}
              {t("Edit Current Payroll")}
            </p>
          </div>
        }
      />
      <div className="container-fluid mainWrapper ">
        <div className=" stock row col-12">
          <div className="col-sm-12 stockCards">
            <div className="payroll-container col-sm-12 mb-2">
              <div className="col-sm-3">
                {/* Pay period */}
                {t("Pay period")}:{" "}
                <span className="pay-period">
                  {moment(rows[0]?.payrollPeriodStart).format("DD MMM")} -{" "}
                  {moment(rows[0]?.payrollPeriodEnd).format("DD MMM")}
                </span>
              </div>
              <div className="col-sm-3 d-flex gap-2">
                {/* Total Net Wages */}
                {t("Total Net Wages")}:{" "}
                <span className="pay-period">
                  {europeanFormatWithSymbol(
                    rows[0]?.payrollExpense.reduce(
                      (acc, curr) =>
                        acc +
                        calculateNetWage(curr.grosswage, curr.employeeTax),
                      0,
                    ),
                  )}
                </span>
              </div>
              <div className="col-sm-3  justify-content-end d-flex width-min-content">
                <div className="row gap-1">
                  <div className="col pe-2">
                    <button
                      className="po-btn-cancel m-auto"
                      onClick={() => history.push("/payroll")}
                    >
                      {/* Cancel */}
                      {t("Cancel")}
                    </button>
                  </div>
                  <div className="col ps-2">
                    <button
                      className="po-btn-complete m-auto"
                      onClick={handleSubmit}
                    >
                      {/* Change */}
                      {t("Change")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tableWrapper-payroll"
              style={{ overflowY: "auto", minHeight: "100%" }}
            >
              <div>
                <table className="table offcyc-table mb-0">
                  <thead>
                    <tr className="off-cycle-header">
                      <th>
                        {/* Members */}
                        {t("Members")}
                      </th>
                      <th>
                        {/* Gross Wage */}
                        {t("Gross Wage")}
                      </th>
                      <th>
                        {/* Employee Taxes */}
                        {t("Employee Taxes")}
                      </th>
                      <th
                        style={{
                          fontWeight: "bold",
                          color: "#707070",
                          // width: "10%",
                        }}
                      >
                        {/* Net Wage */}
                        {t("Net Wage")}
                      </th>
                      <th>
                        {/* Company Taxes */}
                        {t("Company Taxes")}
                      </th>
                      <th style={{ fontWeight: "bold", color: "#707070" }}>
                        {/* Total Payroll Cost */}
                        {t("Total Payroll Cost")}
                      </th>
                      <th>
                        <Dropdown
                          overlay={
                            <PayrollActiveUserModal
                              filteredUsers={filteredUsers}
                              handleAddRow={handleAddRow}
                              searchTerm={searchTerm}
                              setSearchTerm={setSearchTerm}
                            />
                          }
                          trigger={["click"]}
                          placement="bottomLeft"
                        >
                          <img
                            src={plusIcon}
                            className="me-2 pointer"
                            alt="Add Row"
                          />
                        </Dropdown>
                        {/* Enroll Co-Worker */}
                        {t("Enroll Co-Worker")}
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ border: "none" }}>
                    {rows[0]?.payrollExpense?.map((row, index) => (
                      <tr key={index} className="edit-payroll-row">
                        <td
                          style={{
                            padding: "0.5rem 0.75rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            width: "160px",
                            textOverflow: "ellipsis",
                            display: "block",
                          }}
                        >
                          {row.username}
                        </td>
                        <td style={{ padding: "0.5rem 0.75rem" }}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <input
                              type="number"
                              value={row.grosswage}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "grosswage",
                                  e.target.value,
                                )
                              }
                              style={styles.inputStyle}
                            />
                          </div>
                        </td>
                        <td style={{ padding: "0.5rem 0.75rem" }}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <input
                              type="number"
                              value={row.employeeTax}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "employeeTax",
                                  e.target.value,
                                )
                              }
                              style={styles.inputStyle}
                            />
                          </div>
                        </td>
                        <td style={styles.wageText}>
                          {europeanFormatWithSymbol(
                            calculateNetWage(row.grosswage, row.employeeTax),
                          )}
                        </td>
                        <td style={{ padding: "0.5rem 0.75rem" }}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <input
                              type="number"
                              value={row.companyTax}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "companyTax",
                                  e.target.value,
                                )
                              }
                              style={styles.inputStyle}
                            />
                          </div>
                        </td>
                        <td style={styles.wageText}>
                          {europeanFormatWithSymbol(
                            calculateTotalPayrollCost(
                              row.grosswage,
                              row.companyTax,
                            ),
                          )}
                        </td>
                        <td
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            width: "70%",
                          }}
                        >
                          <Button
                            type="text"
                            style={{ color: "gray" }}
                            icon={<DeleteOutlined />}
                            onClick={() => handleDeleteRow(index)}
                          ></Button>
                        </td>
                      </tr>
                    ))}
                    <tr
                      className="off-cycle-header edit-payroll-footer"
                      style={{
                        borderTop: "0.5px solid rgb(243, 236, 236)",
                        position: "absolute",
                        bottom: "0",
                        display: "flex",
                        width: "100%",
                      }}
                    >
                      <th style={{ padding: "0.5rem 0.75rem" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {"Totals"}
                        </div>
                      </th>
                      <th style={{ padding: "0.5rem 0.75rem" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {/* total grossWage */}
                          {europeanFormatWithSymbol(
                            rows[0]?.payrollExpense.reduce(
                              (acc, curr) => +acc + +curr.grosswage,
                              0,
                            ),
                          )}
                        </div>
                      </th>
                      <th style={{ padding: "0.5rem 0.75rem" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "18px",
                          }}
                        >
                          {/* total employeeTax */}
                          {europeanFormatWithSymbol(
                            rows[0]?.payrollExpense.reduce(
                              (acc, curr) => +acc + +curr.employeeTax,
                              0,
                            ),
                          )}
                        </div>
                      </th>
                      <th style={{ padding: "0.5rem 1rem" }}>
                        {/* total net wages */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "18px",
                          }}
                        >
                          {europeanFormatWithSymbol(
                            rows[0]?.payrollExpense.reduce(
                              (acc, curr) =>
                                +acc +
                                calculateNetWage(
                                  +curr.grosswage,
                                  +curr.employeeTax,
                                ),
                              0,
                            ),
                          )}
                        </div>
                      </th>
                      <th style={{ padding: "0.5rem 0.75rem" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "18px",
                          }}
                        >
                          {europeanFormatWithSymbol(
                            rows[0]?.payrollExpense.reduce(
                              (acc, curr) => +acc + +curr.companyTax,
                              0,
                            ),
                          )}
                        </div>
                      </th>
                      <th style={{ padding: "0.5rem 1rem" }}>
                        {/* total payroll cost */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "18px",
                          }}
                        >
                          {europeanFormatWithSymbol(
                            rows[0]?.payrollExpense.reduce(
                              (acc, curr) =>
                                acc +
                                calculateTotalPayrollCost(
                                  +curr.grosswage,
                                  curr.companyTax,
                                ),
                              0,
                            ),
                          )}
                        </div>
                      </th>
                      <th></th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* {rows[0]?.payrollExpense.length > 0 && (
              <div className="align-text-bottom stock-pagination">
                <Pagination
                  perPage={perPage}
                  setPerPage={setPerPage}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalPages={totalPages}
                />
              </div>
            )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default PayrollEdit;
const styles = {
  inputStyle: {
    border: "none",
    outline: "none",
    background: "transparent",
    width: "100%",
    textAlign: "start",
  },
  wageText: {
    padding: "0.5rem 0.75rem",
    color: "#707070",
    overflow: "hidden",
    // width: "10%",
  },
  inputDesc: {
    border: "none",
    outline: "none",
    background: "transparent",
    width: "100%",
    textAlign: "start",
    color: "#333",
    fontWeight: 500,
  },
};
